/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { edit } from "../assets/edit";
import { Icon, type IconBaseProps } from "../icon";

export const IconEdit = (props: IconBaseProps) => <Icon {...props} svg={edit} />;

IconEdit.displayName = "IconEdit";
